import { StyleSheet } from 'aphrodite/no-important';

export const style = (params) =>
  StyleSheet.create({
    column: {
      width: `${100 / params.count}%`,
      paddingTop: params.topPadding,
    },
  });
